module.exports = __webpack_public_path__ + "img/operations.5b41cfa8.svg";